export enum NOTIFICATIONS {
  INFO = 'info',
  SUCCES = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
